import React from 'react';
import { Stack, Alert } from '@mui/material';

const ValidationWarnings = ({ warnings }) => {
  if (!warnings || warnings.length === 0) return null;

  return (
    <Stack spacing={1} className="planner-warnings">
      {warnings.map((w) => (
        <Alert key={w.id} severity={w.severity} variant="outlined" sx={{ borderRadius: '10px' }}>
          {w.message}
        </Alert>
      ))}
    </Stack>
  );
};

export default ValidationWarnings;
